import { useTheme } from '../hooks/useTheme';

/** Topographic contour-line background — fills viewport, non-interactive */
export function TopoBackground(): React.JSX.Element {
  const { isDark } = useTheme();

  const strokeColor = isDark ? 'rgba(244, 196, 63, 0.06)' : 'rgba(0, 0, 0, 0.04)';
  const strokeColorAlt = isDark ? 'rgba(0, 201, 255, 0.04)' : 'rgba(0, 53, 170, 0.03)';

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Primary contour lines */}
        <path d="M0 200 Q300 160 600 220 T1200 180" fill="none" stroke={strokeColor} strokeWidth="1.5" />
        <path d="M0 280 Q350 240 700 300 T1200 260" fill="none" stroke={strokeColor} strokeWidth="1" />
        <path d="M0 360 Q250 320 500 380 T1000 340 L1200 360" fill="none" stroke={strokeColorAlt} strokeWidth="1.5" />
        <path d="M0 440 Q400 400 800 460 T1200 420" fill="none" stroke={strokeColor} strokeWidth="1" />
        <path d="M0 520 Q300 480 600 540 T1200 500" fill="none" stroke={strokeColorAlt} strokeWidth="1" />
        <path d="M0 600 Q350 560 700 620 T1200 580" fill="none" stroke={strokeColor} strokeWidth="1.5" />
        <path d="M0 680 Q250 640 500 700 T1000 660 L1200 680" fill="none" stroke={strokeColorAlt} strokeWidth="1" />

        {/* Secondary lighter lines */}
        <path d="M0 140 Q200 120 400 150 T800 130 L1200 150" fill="none" stroke={strokeColor} strokeWidth="0.5" />
        <path d="M0 480 Q150 460 300 490 T600 470 L1200 490" fill="none" stroke={strokeColorAlt} strokeWidth="0.5" />
        <path d="M0 720 Q400 700 800 730 T1200 710" fill="none" stroke={strokeColor} strokeWidth="0.5" />
      </svg>
    </div>
  );
}
